<template>
  <div v-once style="display:none" ref="jsonld"></div>
</template>

<script>
  import _ from 'lodash'

  export default {
    name: 'GoogleForJobs',
    props: ['googleForJobsInfo'],
    data: function(){
      return {
        googleForJobs: _.cloneDeep(this.googleForJobsInfo)
      }
    },
    mounted: function() {
      const script = document.createElement('script')
      script.type = 'application/ld+json'
      script.textContent = JSON.stringify({
        "@context": "http://schema.org/",
        "@type": "JobPosting",
        "title": this.googleForJobs.title,
        "description": this.googleForJobs.description,
        "datePosted": this.googleForJobs.date_posted,
        "employmentType": this.googleForJobs.employment_type,
        "hiringOrganization": {
          "@type": "Organization",
          "name": this.googleForJobs.hiring_organization_name
        },
        "jobLocation": {
          "@type": "Place",
          "address": {
            "@type": "PostalAddress",
            "addressRegion": this.googleForJobs.job_location_address_region,
            "addressLocality": this.googleForJobs.job_location_address_locality,
            "postalCode": this.googleForJobs.job_location_address_postal_code,
            "addressCountry": "JP"
          }
        },
        "baseSalary": {
          "@type": "MonetaryAmount",
          "currency": "JPY",
          "value": {
            "@type": "QuantitativeValue",
            "minValue": this.googleForJobs.base_salary_min_value,
            "maxValue": this.googleForJobs.base_salary_max_value,
            "unitText": "YEAR"
          }
        }
      })
      document.head.appendChild(script)
    }
  }
</script>
